// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  width: 80px;
  z-index: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: #005D98;
  /* Dropshadow-3/Default */
  /*box-shadow: inset -1px 0 0 #005D98, 0px 8px 24px 0px rgba(28, 28, 28, 0.15);*/

  /* keep the sidebar pinned to the left and not scroll with the main page content */
  position: sticky;
  top: 0;
}

.main {
  display: flex;
  width: 80px;
  /* height: 853px; */
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
}

.head {
  display: flex;
  padding: var(--Spacings-Spacing-04, 16px) 0px;
  flex-direction: column;
  align-items: center;
  gap: var(--Spacings-Spacing-02, 8px);
  align-self: stretch;
  justify-content: space-between;
  height: 100vh;
}

.logo {
  display: flex;
  width: 80px;
  height: 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: -5px;
}

.nav-item-containers {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 83px;
}

.nav-list-icon-containers {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.name {
  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);
  text-align: center;
  line-height: normal;
}

.nav-actions-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  gap: 10px;
  color: #C9C9C9;

  .action-icon {
    cursor: pointer;
    height: 40px;
    width: auto;
    opacity: 0.8;
  }
  .action-icon:hover {
    opacity: 1.0;
  }
  .action-icon:active {
    opacity: 0.5;
  }
}

.nav {
  display: flex;
  width: 96px;
  padding: var(--Spacings-Spacing-04, 16px);
  align-items: center;
  border-top: 1px solid var(--Colors-UI-Neutral-Grey-0, #FFF);
  border-bottom: 1px solid var(--Colors-UI-Neutral-Grey-0, #FFF);
  background: var(--Colors-UI-Primary-Primary-Light, #D9ECFA);
}

.nav-item {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
}

.nav-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-item-left-container {
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
}

.nav-item-left-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.nav-item-right {
  display: flex;
  align-items: center;
  gap: var(--Spacings-Spacing-02, 8px);
}

.nav-item-right-container {
  width: 48px;
  height: 24px;
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
  text-align: right;
  /*font-family: "Euclid Circular A";
  font-family: "Inter";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
   */
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,+EAA+E;;EAE/E,kFAAkF;EAClF,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,cAAc;;EAEd;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,2DAA2D;EAC3D,8DAA8D;EAC9D,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,iBAAiB;EACjB;;;;;IAKE;EACF,mBAAmB;AACrB","sourcesContent":["@import url(\"./global.css\");\n\n:host {\n  display: flex;\n  width: 80px;\n  z-index: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  background: #005D98;\n  /* Dropshadow-3/Default */\n  /*box-shadow: inset -1px 0 0 #005D98, 0px 8px 24px 0px rgba(28, 28, 28, 0.15);*/\n\n  /* keep the sidebar pinned to the left and not scroll with the main page content */\n  position: sticky;\n  top: 0;\n}\n\n.main {\n  display: flex;\n  width: 80px;\n  /* height: 853px; */\n  flex-direction: column;\n  align-items: flex-start;\n  flex-shrink: 0;\n}\n\n.head {\n  display: flex;\n  padding: var(--Spacings-Spacing-04, 16px) 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--Spacings-Spacing-02, 8px);\n  align-self: stretch;\n  justify-content: space-between;\n  height: 100vh;\n}\n\n.logo {\n  display: flex;\n  width: 80px;\n  height: 64px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: -5px;\n}\n\n.nav-item-containers {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 83px;\n}\n\n.nav-list-icon-containers {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n}\n\n.name {\n  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);\n  text-align: center;\n  line-height: normal;\n}\n\n.nav-actions-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 40px;\n  gap: 10px;\n  color: #C9C9C9;\n\n  .action-icon {\n    cursor: pointer;\n    height: 40px;\n    width: auto;\n    opacity: 0.8;\n  }\n  .action-icon:hover {\n    opacity: 1.0;\n  }\n  .action-icon:active {\n    opacity: 0.5;\n  }\n}\n\n.nav {\n  display: flex;\n  width: 96px;\n  padding: var(--Spacings-Spacing-04, 16px);\n  align-items: center;\n  border-top: 1px solid var(--Colors-UI-Neutral-Grey-0, #FFF);\n  border-bottom: 1px solid var(--Colors-UI-Neutral-Grey-0, #FFF);\n  background: var(--Colors-UI-Primary-Primary-Light, #D9ECFA);\n}\n\n.nav-item {\n  display: flex;\n  height: 32px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n}\n\n.nav-item-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.nav-item-left-container {\n  display: flex;\n  width: 24px;\n  height: 24px;\n  justify-content: center;\n  align-items: center;\n}\n\n.nav-item-left-icon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.nav-item-right {\n  display: flex;\n  align-items: center;\n  gap: var(--Spacings-Spacing-02, 8px);\n}\n\n.nav-item-right-container {\n  width: 48px;\n  height: 24px;\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n  text-align: right;\n  /*font-family: \"Euclid Circular A\";\n  font-family: \"Inter\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n   */\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
